import React from 'react'
import { pxToRem, color } from '../../utils'
import styled from 'styled-components'
import { NavLink, withRouter } from 'react-router-dom'
import Button from '../Form/Button'
import ReturnPageIcon from '../icons/ReturnPageButton'

const ReturnButton = styled(Button)`
  align-items: center;
  background: transparent;
  border-color: ${color.primary};
  color: ${color.primary};
  display: flex;
  font-size: ${pxToRem(12)};
  font-weight: bold;
  justify-content: center;
  padding: ${pxToRem(8)} ${pxToRem(15)};

  svg {
    margin-left: ${pxToRem(10)};
  }
`

const ReturnButtonLink = styled(NavLink)`
text-decoration: none
`

const ReturnPageButton = props => {
  const { pathname, ...rest } = props

  return (
    <ReturnButtonLink
      to={pathname}
    >
      <ReturnButton {...rest}
      >
        Voltar a página anterior
        <ReturnPageIcon />
      </ReturnButton>
    </ReturnButtonLink>

  )
}

export default withRouter(ReturnPageButton)



// WEBPACK FOOTER //
// ./src/components/ReturnPageButton/ReturnPageButton.js